import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthAxios from "../../config/authAxios";
import apiRoutes from "../apiConfigs";

export const channelcodeDeleteApi = createAsyncThunk(
  "auth/channelcode/delete",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AuthAxios.delete(apiRoutes.channelCodeAction('delete',1,id,1));
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

const channelcodeDeleteSlice = createSlice({
  name: "channelcode delete",
  initialState: { result: [], loading: false, error: null, message: "" },
  extraReducers: (builder) => {
    builder.addCase(channelcodeDeleteApi.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(channelcodeDeleteApi.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action?.payload?.result;
      state.message = action?.payload?.message;
    });
    builder.addCase(channelcodeDeleteApi.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.message = action?.payload?.message;
    });
  },
});

export const channelcodeDeleteReducer = channelcodeDeleteSlice.reducer;
